import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  font-size: 24px;
  max-width: 585px;
  padding: 0 10px;

  @media (max-width: 800px) {
    max-width: 80vw;
    margin: auto;
  }
`;

export const Image = styled.div`
  height: 350px;
  width: 585px;
  padding: 10px 0;

  video {
    width: 570px;
  }
`;

export const Content = styled.div`
  font-size: 17px;
`;

export const Actions = styled.div`
  border-top: 1px solid #e0e0e0;
  padding-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
`;

export const Notes = styled.div`
  font-size: 15px;
  color: #999;
  line-height: 1.5;
  flex: 1;

  a {
    color: pink;
  }
`;

export const Cta = styled.button`
  padding: 10px 30px 10px 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Column = styled.div`
  flex: 1;

  .Checkbox-wrapper {
    margin-top: 5px;
    padding-top: 5px;
    opacity: 0.7;
  }
`;
